import styled from 'styled-components';
import { Flex, Icon } from '@amzn/storm-ui';

export const AccordionContainer = styled.div`
  border: 0.0625rem solid
    ${({ theme }) => theme.button.backgroundColor.secondary.default};
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: visible;
`;

export const AccordionHeader = styled.div`
  display: flex;
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background-color: ${({ theme }) =>
    theme.button.backgroundColor.secondary.active};
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) =>
      theme.button.backgroundColor.secondary.hover};
  }
`;

export const AccordionHeaderLeft = styled(Flex)`
  align-items: center;
  gap: 0.5rem;
`;

export const ChevronIcon = styled(Icon)<{ isExpanded: boolean }>`
  transition: transform 0.25s ease;
  transform: rotate(${({ isExpanded }) => (isExpanded ? '0deg' : '-90deg')});
  color: ${({ theme }) =>
    theme.buttonGroup.backgroundColor.unavailable.selected};
  font-size: 0.75rem;
`;

export const AccordionContentWrapper = styled.div<{ isExpanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ isExpanded }) => (isExpanded ? '1fr' : '0fr')};
  transition: grid-template-rows 0.1s ease-in-out;
  overflow: ${({ isExpanded }) => (isExpanded ? 'visible' : 'hidden')};
`;

export const AccordionContentInner = styled.div<{ isExpanded: boolean }>`
  min-height: 0;
  overflow: ${({ isExpanded }) => (isExpanded ? 'visible' : 'hidden')};
  padding: ${({ isExpanded }) => (isExpanded ? '1rem' : '0')};
`;
